import { render, staticRenderFns } from "./BuildingForm.vue?vue&type=template&id=5bbc9446&scoped=true&"
import script from "./BuildingForm.vue?vue&type=script&lang=js&"
export * from "./BuildingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc9446",
  null
  
)

export default component.exports